import React from 'react';
import { Box, Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import logo from '../../../assets/logo_normal.svg';
//import logo from '../../../assets/logo-blanco-navidad.svg';
import logoTN from '../../../assets/logo_tn.svg';
import volarWhite from '../../../assets/external-logos/volar-white.svg';
import sevensWhite from '../../../assets/external-logos/sevens-white.svg';

const useStyles = makeStyles((theme) => ({
	paper: {
		backgroundColor: theme.palette.primary.main,
		textAlign: 'center',
		padding: theme.spacing(2),
		borderBottom: 'solid',
		color: theme.palette.secondary.main,
	},
}));

interface Props {
	countryCode?: string | null;
	isExternal?: boolean;
}

export const Header = ({ countryCode, isExternal }: Props): JSX.Element => {
	const classes = useStyles();

	if (isExternal) {
		return (
			<Box
				sx={{
					backgroundColor: '#06036c',
					padding: 2,
					borderBottom: 'solid',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
			>
				<Container maxWidth="md" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<img width={120} src={volarWhite} alt="Volar logo" />
					<img width={120} src={sevensWhite} alt="Sevens Travel logo" />
				</Container>
			</Box>
		);
	}

	return countryCode === 'TN' ? (
		<Box
			sx={{
				backgroundColor: 'white',
				height: '72px',
				boxShadow: 'rgba(0, 0, 0, 0.25) 0px 8px 16px',
				paddingTop: '14px',
			}}
		>
			<Container maxWidth="md">
				<img width={172} src={logoTN} alt="Tienda Naranaja Viajes logo" />
			</Container>
		</Box>
	) : (
		<div className={classes.paper}>
			<Box>
				<img width={172} src={logo} alt="logo" />
			</Box>
		</div>
	);
};
